import { API_BASE_URL, getActiveArtistId, getAuthToken, request } from './client'

export const getManagerAccounting = () => request('/manager/accounting')
export const getManagerWorkflow = () => request('/manager/langgraph/state')
export const startManagerWorkflow = (metadata = {}) =>
  request('/manager/langgraph/start', { method: 'POST', body: { metadata } })
export const pauseManagerWorkflow = (runId) =>
  request('/manager/langgraph/pause', { method: 'POST', body: { runId } })
export const checkpointManagerWorkflow = () =>
  request('/manager/langgraph/checkpoint', { method: 'POST' })
export const getManagerWorkflowStreamUrl = () => {
  let basePath = API_BASE_URL || '/api'
  if (basePath.startsWith('http')) {
    try {
      const parsed = new URL(basePath)
      basePath = parsed.pathname || ''
    } catch {
      basePath = '/api'
    }
  }
  if (!basePath.startsWith('/')) {
    basePath = `/${basePath}`
  }
  basePath = basePath.replace(/\/$/, '')
  const params = new URLSearchParams()
  const artistId = getActiveArtistId()
  const token = getAuthToken()
  if (artistId) {
    params.set('artistId', artistId)
  }
  if (token) {
    params.set('token', token)
  }
  const suffix = params.toString()
  return `${basePath || '/api'}/manager/langgraph/stream${suffix ? `?${suffix}` : ''}`
}

export const getManagerGoals = () => request('/manager/goals')
export const createManagerGoal = (body) =>
  request('/manager/goals', {
    method: 'POST',
    body,
  })
export const updateManagerGoal = (goalId, body) =>
  request(`/manager/goals/${encodeURIComponent(goalId)}`, {
    method: 'PATCH',
    body,
  })
export const syncManagerGoal = (goalId) =>
  request(`/manager/goals/${encodeURIComponent(goalId)}/sync`, {
    method: 'POST',
  })

export const submitGoalTaskApproval = (goalId, taskId, body) =>
  request(
    `/manager/goals/${encodeURIComponent(goalId)}/tasks/${encodeURIComponent(taskId)}/approval`,
    {
      method: 'POST',
      body,
    },
  )

export const getManagerEvents = (limit = 20, offset = 0, artistId = null) =>
  request(`/manager/events?limit=${encodeURIComponent(limit)}&offset=${encodeURIComponent(offset)}`, { headers: artistId ? { "X-Artist-Id": artistId } : {} })
export const createManagerEvent = (body) =>
  request('/manager/events', {
    method: 'POST',
    body,
  })
export const updateManagerEvent = (eventId, body) =>
  request(`/manager/events/${encodeURIComponent(eventId)}`, {
    method: 'PATCH',
    body,
  })
export const importManagerEvents = (body = {}, artistId = null) =>
  request('/manager/events/import', {
    method: 'POST',
    headers: artistId ? { 'X-Artist-Id': artistId } : {},
    body,
  })

export const getManagerRoutes = (limit = 5) =>
  request(`/manager/routes?limit=${encodeURIComponent(limit)}`)
export const createManagerRoutes = (body) =>
  request('/manager/routes', {
    method: 'POST',
    body,
  })

export const recordCashFlowInputs = (body) =>
  request('/manager/cash-flow/inputs', {
    method: 'POST',
    body,
  })

export const resolveManagerPrompt = (promptId, body = {}) =>
  request(`/manager/langgraph/prompts/${encodeURIComponent(promptId)}/resolve`, {
    method: 'POST',
    body,
  })

const exportImportForm = (files, extra = {}) => {
  const form = new FormData()
  for (const file of files) form.append('files', file)
  for (const [key, value] of Object.entries(extra)) {
    if (value !== undefined && value !== null) form.append(key, typeof value === 'string' ? value : JSON.stringify(value))
  }
  return form
}

// Bandsintown for Artists export (CSV/XLSX) → private Shows. Preview never writes.
export const previewShowExportImport = (files, decisions = {}, artistId = null) =>
  request('/manager/events/import-file/preview', {
    method: 'POST',
    headers: artistId ? { 'X-Artist-Id': artistId } : {},
    body: exportImportForm(files, { decisions }),
    timeoutMs: 60000,
  })

export const commitShowExportImport = (files, decisions, previewToken, { confirmArtistName = false } = {}, artistId = null) =>
  request('/manager/events/import-file/commit', {
    method: 'POST',
    headers: artistId ? { 'X-Artist-Id': artistId } : {},
    body: exportImportForm(files, { decisions, preview_token: previewToken, confirm_artist_name: confirmArtistName ? 'true' : 'false' }),
    timeoutMs: 60000,
  })
